import { CELL_STATE } from "../cell";
import { getLogger } from "../logging";
import "../ripple";
import { gameState, levelDef } from "./gameState";

const log = getLogger("Utils");

const _CELL_STATE_MAP = {
    [CELL_STATE.BLOCKED]: "x",
    [CELL_STATE.NON_BLOCKABLE]: "n",
    [CELL_STATE.NON_BLOCKABLE_OUTSIDE]: ",",
    [CELL_STATE.FREE]: "o",
    [CELL_STATE.OUTSIDE]: ".",
    [CELL_STATE.CATCH]: "c",
    [CELL_STATE.DROP]: "d",
    [CELL_STATE.FREEZE]: "f",
    [CELL_STATE.CENTER]: "t",
    [CELL_STATE.SHUFFLE]: "s",
    [CELL_STATE.RANDOM]: "r",
    [CELL_STATE.ERASE]: "/",
    cat: "C",
  };

export function getBoardString(shrink = 0, markWin = false) {
  let boardStr = "";
  for (let i = shrink; i < levelDef.fieldSize - shrink; i++) {
    if (i % 2 == 1) boardStr += " ";
    for (let j = shrink; j < levelDef.fieldSize - shrink; j++) {
      let foundCat = false;
      for (const cat of gameState.cats.getAll()) {
        if (cat.x == j && cat.y == i) {
          boardStr += _CELL_STATE_MAP.cat + " ";
          foundCat = true;
        }
      }
      if (!foundCat) {
        if (markWin && gameState.cells[i][j].win) boardStr += "w ";
        else {
          const symbol = _CELL_STATE_MAP[gameState.cells[i][j].state] || "?";
          if (symbol == "?")
            log.warn(
              `Unknown symbol for state ${gameState.cells[i][j].state}`
            );
          boardStr += symbol + " ";
        }
      }
    }
    boardStr += "\n";
  }
  return boardStr;
}

if (__DEV__) window.getBoardString = getBoardString;
